import { useTranslation } from 'react-i18next';
import Proyectos from './proyecto.component.js';
import { useContext, useState } from 'react';
import { AuthContext } from '../../utils/context/auth.context.ts';
import ProyectosCli from './proyecto.cli.component.js';

export default function PRO() {
    const { t } = useTranslation();
    const authContext = useContext(AuthContext)
    const [isCli] = useState(authContext.isCli());

    return (
        <div>
            <h2>{t("pro.title")}</h2>

            {isCli ?  <ProyectosCli /> : <Proyectos />}


        </div>

    );
}
